module.exports = __webpack_public_path__ + "static/img/Luciano-Leilua.a5914d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luciano-Leilua.jpg
// module id = gXoy
// module chunks = 0